import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GlobalContainerSettings = styled(Box)({
	height: '90vh',
	flexDirection: 'row',
});

export const HeaderSettings = styled(Box)({
	minHeight: '10vh',
	color: '#f17e22',
	fontSize: '30px',
	fontWeight: 'bold',
	padding: '65px',
});

export const MainSettings = styled(Box)({
	height: '70vh',
});

export const MenuItemBox = styled(Box)({
	'@media only screen and (max-width: 600px)': {
		width: '90%',
	},

	/* Small devices (portrait tablets and large phones, 600px and up) */
	'@media only screen and (min-width: 600px)': {
		width: '75%',
	},

	/* Medium devices (landscape tablets, 768px and up) */
	'@media only screen and (min-width: 768px)': {
		width: '60%',
	},

	/* Large devices (laptops/desktops, 992px and up) */
	'@media only screen and (min-width: 992px)': {
		width: '50%',
	},

	/* Extra large devices (large laptops and desktops, 1200px and up) */
	'@media only screen and (min-width: 1200px)': {
		width: '55%',
	},
	marginBottom: '5px',
	marginTop: '5px',
	height: '80px',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	marginLeft: 'auto',
	marginRight: 'auto',
	padding: '20px',
	borderWidth: '1px',
	borderRadius: '10px',
	borderColor: 'black',
});

export const MenuItemLanguage = styled(MenuItem)({
	width: '80%',
	marginLeft: '5px',
	marginRight: '5px',
	padding: '10px',
	display: 'flex',
	flexDirection: 'row',
	marginLeft: 'auto',
	marginRight: 'auto',
	borderRadius: '5px',
});


export const MenuDivider = styled(Divider)({
	'@media only screen and (max-width: 600px)': {
		width: '77%',
	},

	/* Small devices (portrait tablets and large phones, 600px and up) */
	'@media only screen and (min-width: 600px)': {
		width: '68%',
	},

	/* Medium devices (landscape tablets, 768px and up) */
	'@media only screen and (min-width: 768px)': {
		width: '55%',
	},

	/* Large devices (laptops/desktops, 992px and up) */
	'@media only screen and (min-width: 992px)': {
		width: '45%',
	},

	/* Extra large devices (large laptops and desktops, 1200px and up) */
	'@media only screen and (min-width: 1200px)': {
		width: '55%',
	},
});

export const MenuItemLogout = styled(Box)({
	'@media only screen and (max-width: 600px)': {
		width: '70%',
	},

	/* Small devices (portrait tablets and large phones, 600px and up) */
	'@media only screen and (min-width: 600px)': {
		width: '75%',
	},

	/* Medium devices (landscape tablets, 768px and up) */
	'@media only screen and (min-width: 768px)': {
		width: '60%',
	},

	/* Large devices (laptops/desktops, 992px and up) */
	'@media only screen and (min-width: 992px)': {
		width: '50%',
	},

	/* Extra large devices (large laptops and desktops, 1200px and up) */
	'@media only screen and (min-width: 1200px)': {
		width: '40%',
	},
	height: '50px',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	marginLeft: 'auto',
	marginRight: 'auto',
	padding: '18px',
	borderWidth: '1px',
	borderRadius: '55px',
	borderColor: 'black',
	cursor: 'pointer',
	':active': {
		borderColor: 'rgb(171, 171, 171)',
		borderWidth: '1px',
		backgroundColor: '#c7a985a3',
		borderStyle: 'solid',
	},

	position: 'relative',
	justifyContent: 'center',
	alignContent: 'center',
	marginTop: 40,
});

export const BtnSettingsText = styled(Box)({
	paddingLeft: '14px',
	fontSize: '20px',
	fontWeight: 'bold',
	width: '100vw',
	textAlign: 'left',
});

export const LabelText = styled(InputLabel)({
	fontSize: '20px',
	fontWeight: 'bold',
	textAlign: 'left',
});

export const FooterSettings = styled(Box)({
	position: 'fixed',
	height: '10vh',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	alignContent: 'center',
	bottom: 4,
});
